class Accordion {
    constructor() {
        this.activeClass = 'is-open';
        this.toggleState = 'close';
    }

    init(wrapper) {
        this.wrapper = wrapper;
        this.items = Array.from(wrapper.querySelectorAll('.j-accordion-item'));

        this._bindEvents();
    }

    toggle() {
        /* eslint-disable */
        this.toggleState === 'close' ? this._expandAll() : this._closeAll();
        /* eslint-enable */
    }

    _bindEvents() {
        this._intitItems();

        window.addEventListener('resize', () => {
            this.update();
        });
    }

    _intitItems() {
        if (this.items.length) {
            this.items.forEach((item) => {
                const head = item.querySelector('.j-accordion-item-head');

                head.addEventListener('click', () => {
                    if (head.classList.contains(this.activeClass)) {
                        this._closeItem(item);
                        // body.classList.remove(this.activeClass);
                        // body.style.height = 0;
                    } else {
                        this._openItem(item);
                        // body.classList.add(this.activeClass);
                        // body.style.height = `${body.scrollHeight}px`;
                    }
                });
            });
        }
    }

    _expandAll() {
        if (this.items.length) {
            this.items.forEach((item) => {
                if (!item.classList.contains(this.activeClass)) {
                    this._openItem(item);
                }
            });

            this.toggleState = 'open';
        }
    }

    _closeAll() {
        if (this.items.length) {
            this.items.forEach((item) => {
                if (!item.classList.contains(this.activeClass)) {
                    this._closeItem(item);
                }
            });

            this.toggleState = 'close';
        }
    }

    _openItem(item) {
        const head = item.querySelector('.j-accordion-item-head');
        const body = item.querySelector('.j-accordion-item-content');

        head.classList.add(this.activeClass);
        body.classList.add(this.activeClass);
        body.style.height = `${body.scrollHeight}px`;
    }

    _closeItem(item) {
        const head = item.querySelector('.j-accordion-item-head');
        const body = item.querySelector('.j-accordion-item-content');

        head.classList.remove(this.activeClass);
        body.classList.remove(this.activeClass);
        body.style.height = 0;
    }

    update() {
        const activeItems = Array.from(this.wrapper.querySelectorAll(`.j-accordion-item-content.${this.activeClass}`));

        if (activeItems.length) {
            activeItems.forEach((item) => {
                item.style.height = `100%`;
                item.style.height = `${item.offsetHeight}px`;
            });
        }
    }
}

export default Accordion;
